<template>
  <div class="content_div">
    <el-card>
      <!-- 搜索区域 -->
      <el-form :inline="true" :model="query" class="demo-form-inline" style="margin-bottom: 20px;">
        <el-form-item label="标题">
          <el-input clearable class="input_class" v-model="query.title" auto-complete="off" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="query.status" placeholder="请选择状态" clearable>
            <el-option label="全部" value="" />
            <el-option label="启用" :value="1" />
            <el-option label="停用" :value="0" />
          </el-select>
        </el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
        <el-button type="success" @click="btnInsert()">新增</el-button>
      </el-form>

      <el-table
        v-loading="loading"
        :data="dataList"
        border
      >
        <el-table-column label="ID" align="center" prop="id" width="80" />
        <el-table-column label="大标题" align="center" prop="title" min-width="150" />
        <el-table-column label="二级标题" align="center" prop="subtitle" min-width="150" show-overflow-tooltip />
        <el-table-column label="轮播图" align="center" width="150">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.imageUrl"
              style="width: 100px; height: 60px"
              :src="scope.row.imageUrl"
              :preview-src-list="[scope.row.imageUrl]"
              fit="cover">
            </el-image>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="跳转地址" align="center" prop="linkUrl" min-width="200" show-overflow-tooltip />
        <el-table-column label="排序" align="center" prop="sort" width="80" />
        <el-table-column label="状态" align="center" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
              {{ scope.row.status === 1 ? '启用' : '停用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="备注" align="center" prop="remark" min-width="150" show-overflow-tooltip />
        <el-table-column label="操作" align="center" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="btnUpdate(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="btnDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="query.currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="margin-top: 20px; text-align: right;"
      />
    </el-card>

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="isShowDialogFlag" width="700px" :close-on-click-modal="false">
      <el-form ref="form" :model="data" :rules="rules" label-width="120px">
        <el-form-item label="大标题" prop="title">
          <el-input v-model="data.title" placeholder="请输入大标题" maxlength="100" show-word-limit></el-input>
        </el-form-item>

        <el-form-item label="二级标题">
          <el-input v-model="data.subtitle" placeholder="请输入二级标题（选填）" maxlength="200" show-word-limit></el-input>
        </el-form-item>

        <el-form-item label="轮播图" prop="imageUrl">
          <square-crop-upload
            v-model="data.imageUrl"
            :max-size="2048*5"
            :auto-upload="true"
          />
          <div class="upload-tip">建议尺寸：1920x600像素，支持jpg、png格式，大小不超过5MB</div>
        </el-form-item>

        <el-form-item label="跳转地址">
          <el-input v-model="data.linkUrl" placeholder="请输入跳转地址（选填）" maxlength="500"></el-input>
        </el-form-item>

        <el-form-item label="排序号" prop="sort">
          <el-input-number v-model="data.sort" :min="0" :max="9999" label="排序号，数字越小越靠前"></el-input-number>
          <span class="form-tip">数字越小越靠前</span>
        </el-form-item>

        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="data.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="备注">
          <el-input
            v-model="data.remark"
            type="textarea"
            :rows="3"
            placeholder="请输入备注"
            maxlength="500"
            show-word-limit>
          </el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="isShowDialogFlag = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getBannerPage, insertBanner, updateBanner, deleteBanner } from '@/api/ordering/banner'
import SquareCropUpload from '@/components/core/images/SquareCropUpload'

export default {
  name: 'BannerManage',
  components: {
    SquareCropUpload
  },
  async created() {
    await this.load()
  },
  data() {
    return {
      loading: true,
      total: 0,
      dataList: [],
      query: {
        currentPage: 1,
        pageSize: 10,
        title: undefined,
        status: undefined
      },
      isShowDialogFlag: false,
      dialogTitle: '',
      data: {
        id: null,
        title: null,
        subtitle: null,
        imageUrl: null,
        linkUrl: null,
        sort: 0,
        status: 1,
        remark: null
      },
      rules: {
        title: [
          { required: true, message: '请输入大标题', trigger: 'blur' }
        ],
        imageUrl: [
          { required: true, message: '请上传轮播图', trigger: 'change' }
        ],
        sort: [
          { required: true, message: '请输入排序号', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    async load() {
      this.loading = true
      try {
        const res = await getBannerPage(this.query)
          this.dataList = res.records
          this.total = res.total
      } catch (error) {
        console.error('加载数据失败:', error)
        this.$message.error('加载数据失败')
      } finally {
        this.loading = false
      }
    },

    // 图片上传成功（SquareCropUpload组件自动处理，不需要此方法）
    // handleImageSuccess 方法已移除，由组件自动处理

    btnInsert() {
      this.dialogTitle = '新增轮播图'
      this.resetData()
      this.isShowDialogFlag = true
    },

    btnUpdate(row) {
      this.dialogTitle = '编辑轮播图'
      this.data = {
        id: row.id,
        title: row.title,
        subtitle: row.subtitle,
        imageUrl: row.imageUrl,
        linkUrl: row.linkUrl,
        sort: row.sort,
        status: row.status,
        remark: row.remark
      }
      this.isShowDialogFlag = true
    },

    async btnDelete(id) {
      this.$confirm('确定要删除该轮播图吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await deleteBanner(id)
          if (res.code === 200) {
            this.$message.success('删除成功')
            await this.load()
          } else {
            this.$message.error(res.message || '删除失败')
          }
        } catch (error) {
          console.error('删除失败:', error)
          this.$message.error('删除失败')
        }
      }).catch(() => {})
    },

    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            let res
            if (this.data.id) {
              res = await updateBanner(this.data)
            } else {
              res = await insertBanner(this.data)
            }

            if (res.code === 200) {
              this.$message.success(this.data.id ? '修改成功' : '新增成功')
              this.isShowDialogFlag = false
              await this.load()
            } else {
              this.$message.error(res.message || '操作失败')
            }
          } catch (error) {
            console.error('保存失败:', error)
            this.$message.error('保存失败')
          }
        }
      })
    },

    resetData() {
      this.data = {
        id: null,
        title: null,
        subtitle: null,
        imageUrl: null,
        linkUrl: null,
        sort: 0,
        status: 1,
        remark: null
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },

    handleSizeChange(val) {
      this.query.pageSize = val
      this.load()
    },

    handleCurrentChange(val) {
      this.query.currentPage = val
      this.load()
    }
  }
}
</script>

<style scoped>
.upload-tip {
  color: #999;
  font-size: 12px;
  margin-top: 5px;
}

.form-tip {
  color: #999;
  font-size: 12px;
  margin-left: 10px;
}
</style>
